module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ifERF"))).then(() => parcelRequire('3a9aZ'));